/** Convert Tag[] → string[] for form state */
export default function convertTagsToStrings(tags: { label: string; value: string }[]): string[] {
  return tags.map((tag: { label: string; value: string }) => tag.value);
}
